<template>
  <div v-if="value.med">
    <v-text-field
      v-model="value.medUsed"
      :label="$t('medkitlogs.whatWasUsed')"
      data-cy="medUsed"
      :rules="requieredRule"
    ></v-text-field>
  </div>
</template>
<script>
import i18n from "../../../i18n";
export default {
  props: ["value"],
  data: () => ({ requieredRule: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")] }),
  methods: {},
};
</script>
